import { useQuery } from '@tanstack/react-query';
import { privateApi } from '../../../api/api';
import { ExtraReportResponse, ExtraReportResponseSchema } from '../response/ExtraReportResponse';

const API_VERSION = "v4";

interface UseExtraReportProps {
    filter: {
        property_id: string;
        start_date: string;
        end_date: string;
        date_base?: string;
        room_type_id?: string | null;
    };
}

const useExtraReport = ({ filter }: UseExtraReportProps) => {
    return useQuery<ExtraReportResponse>({
        queryKey: [
            'extra-report',
            filter.property_id,
            filter.start_date,
            filter.end_date,
            filter.date_base,
            filter.room_type_id,
        ],
        queryFn: async () => {
            const params: Record<string, any> = {
                'filter[property_id]': filter.property_id,
                'filter[start_date]': filter.start_date,
                'filter[end_date]': filter.end_date,
            };

            if (filter.date_base) {
                params['filter[date_base]'] = filter.date_base;
            }

            if (filter.room_type_id) {
                params['filter[room_type_id]'] = filter.room_type_id;
            }

            const response = await privateApi.get(`/${API_VERSION}/fos/extra-report`, { params });

            const validationResult = ExtraReportResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Extra Report data format");
            }
            return validationResult.data;
        },
        enabled: !!filter.property_id && !!filter.start_date && !!filter.end_date,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useExtraReport;
